import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DownloadCollectionService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  getCollection(categoryId: number, language: string, filterValues?: number[], searchTerm?: string): Observable<Blob> {
    const url = this.apiData.apiURL + `api/${this.client}/downloadcenter/collection/` + categoryId + '/' + language;
    const body = {
      filter_values: filterValues,
      search_terms: searchTerm,
    };

    return this.http.post(url, body, { responseType: 'blob' });
  }
}
